var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPlaystore(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 21,
    viewBox: "0 0 18 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_141_179)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2.94315 17.9071C3.68042 18.9684 4.68849 20.4196 5.98911 20.4196V20.4171H6.05538C6.55187 20.3856 7.03731 20.2557 7.48386 20.0348H7.49636C8.06154 19.7584 8.68112 19.6135 9.30931 19.6109C9.91095 19.6175 10.5036 19.7591 11.0441 20.0253H11.0478C11.4995 20.2546 11.9964 20.3789 12.5019 20.3894H12.5757C13.8842 20.3698 14.7206 19.2701 15.5958 17.9437C16.1967 17.0773 16.6623 16.1234 16.9768 15.1151V15.11C16.4841 14.901 16.0339 14.6021 15.649 14.2282C15.2239 13.8241 14.8864 13.3357 14.6579 12.7937C14.4294 12.2517 14.3147 11.6679 14.3211 11.0791C14.3335 10.3148 14.5363 9.56593 14.9109 8.90119C15.2854 8.23644 15.8198 7.67725 16.4648 7.27484C16.0536 6.68403 15.5116 6.19776 14.8816 5.8545C14.2516 5.51124 13.551 5.32042 12.8351 5.29714C12.7158 5.28643 12.6089 5.28076 12.5176 5.28076C11.7279 5.33075 10.9543 5.52854 10.2364 5.86399H10.2214C9.85218 6.04432 9.4559 6.1618 9.04864 6.21166C8.61915 6.16582 8.20112 6.04363 7.81394 5.85077H7.80018C7.17964 5.55404 6.50843 5.3798 5.82282 5.33745H5.76656C4.932 5.36389 4.11849 5.60787 3.40544 6.04556C2.69237 6.48325 2.10412 7.0997 1.69807 7.83474C0.879547 9.45499 0.641915 11.3105 1.0254 13.087C1.32761 14.8069 1.97885 16.4455 2.93837 17.9002L2.94315 17.9071Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.89361 5.06491C8.95802 5.07069 9.0227 5.07322 9.08745 5.07247C9.61816 5.04547 10.1373 4.9061 10.6111 4.66345C11.0848 4.42079 11.5025 4.0803 11.8368 3.66414C12.5779 2.77317 12.942 1.62463 12.8508 0.46582C11.7234 0.584496 10.6819 1.12695 9.93386 1.98499C9.19555 2.83207 8.82136 3.93992 8.89361 5.06491Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_141_179"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16.6739,
    height: 20.2986,
    fill: "white",
    transform: "translate(0.846544 0.46582)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlaystore);
export default __webpack_public_path__ + "static/media/playstore.b5245f26b52c5ef2284819fc71543c8c.svg";
export { ForwardRef as ReactComponent };